// @ts-nocheck
import { useState, useCallback } from "react"
import { supabaseClient } from "@/lib/supabase/client"
import { useToast } from "@/components/ui/ToastProvider"

export function useVote({ targetId, targetType, initialVote, initialScore, userId, onVoteChange }: any) {
  const [vote, setVote] = useState(initialVote)
  const [score, setScore] = useState(initialScore)
  const [isVoting, setIsVoting] = useState(false)
  const { info } = useToast()

  const castVote = useCallback(async (type: "up" | "down") => {
    if (!userId) { info("Sign in to vote"); return }
    if (isVoting) return
    const prev = vote
    let delta = 0
    let newVote: "up" | "down" | null
    if (prev === type) { delta = type === "up" ? -1 : 1; newVote = null }
    else if (!prev) { delta = type === "up" ? 1 : -1; newVote = type }
    else { delta = type === "up" ? 2 : -2; newVote = type }
    setVote(newVote); setScore((s: number) => s + delta)
    onVoteChange?.(newVote, delta)
    setIsVoting(true)
    try {
      const col = targetType === "post" ? "post_id" : "comment_id"
      if (newVote === null) {
        await supabaseClient.from("votes").delete()
          .eq(col, targetId).eq("user_id", userId)
      } else {
        await supabaseClient.from("votes").upsert({
          [col]: targetId, user_id: userId, vote_type: newVote
        } as any)
      }
    } catch { setVote(prev); setScore((s: number) => s - delta); onVoteChange?.(prev, -delta) }
    finally { setIsVoting(false) }
  }, [targetId, targetType, vote, score, userId, isVoting, onVoteChange, info])

  return { vote, score, isVoting, castVote }
}
